import { Component, OnInit } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-field-surveypolicyprocedure",
    template: `
    <table>
      <tr>
        <td>
          <table style="border: 1px solid black;font-size:1.2em;">
            <tr style="border: 1px solid black;">
              <td style="text-align: center;"><strong>Policy</strong></td>
            </tr>
            <tr style="border: 1px solid black;">
              <td
                style="text-align: center;border-right: 1px solid black;padding:3px;"
              >
                <label class="form-check form-check-inline cursor-hand">
                  <input
                    [name]="id + 'policy'"
                    [id]="id + '_policy_yes'"
                    type="radio"
                    [value]="true"
                    (ngModelChange)="onModelChange('policy', true)"
                    [ngModel]="myModel.policy"
                    class="form-check-input"
                  />
                  <span
                    class="cursor-hand form-check-label"
                    [innerHTML]="'Yes'"
                  ></span>
                </label>
                <label class="form-check form-check-inline cursor-hand">
                  <input
                    [name]="id + 'policy'"
                    [id]="id + '_policy_no'"
                    type="radio"
                    [value]="false"
                    (ngModelChange)="onModelChange('policy', false)"
                    [ngModel]="myModel.policy"
                    class="form-check-input"
                  />
                  <span
                    class="cursor-hand form-check-label"
                    [innerHTML]="'No'"
                  ></span>
                </label>
              </td>
            </tr>
          </table>
        </td>
        <td style="padding-left:15px">
          <table style="border: 1px solid black;font-size:1.2em;">
            <tr style="border: 1px solid black;">
              <td style="text-align: center;"><strong>Procedure</strong></td>
            </tr>
            <tr style="border: 1px solid black;">
              <td style="text-align: center;padding:3px;">
                <label class="form-check form-check-inline cursor-hand">
                  <input
                    [name]="id + 'procedure'"
                    [id]="id + '_procedure_yes'"
                    type="radio"
                    [value]="true"
                    (ngModelChange)="onModelChange('procedure', true)"
                    [(ngModel)]="myModel.procedure"
                    class="form-check-input"
                  />
                  <span
                    class="cursor-hand form-check-label"
                    [innerHTML]="'Yes'"
                  ></span>
                </label>
                <label class="form-check form-check-inline cursor-hand">
                  <input
                    [name]="id + 'procedure'"
                    [id]="id + '_procedure_no'"
                    type="radio"
                    [value]="false"
                    (ngModelChange)="onModelChange('procedure', false)"
                    [(ngModel)]="myModel.procedure"
                    class="form-check-input"
                  />
                  <span
                    class="cursor-hand form-check-label"
                    [innerHTML]="'No'"
                  ></span>
                </label>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  `,
    styleUrls: ["./common.css"],
    standalone: false
})
export class FormlyFieldSurveyPolicyProcedureComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  public myModel = null;

  ngOnInit(): void {
    this.myModel = JSON.parse(
      this.model[this.key.toString()] || '{ "policy": null, "procedure": null }'
    );
  }

  public onModelChange(type: string, newValue: boolean) {
    switch (type) {
      case "policy":
        this.myModel.policy = newValue;
        break;
      case "procedure":
        this.myModel.procedure = newValue;
      default:
        break;
    }

    this.formControl.setValue(JSON.stringify(this.myModel));
  }
}
